import { createQueryParams } from '@nexio/emvio-util-app';
import config from '../../config/config';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';
import { navigateToMerchantDetails } from './utils/navigationUtils';
import {
    MERCHANT_ONBOARDING_LOAD,
    MERCHANT_ONBOARDING_SUCCESS,
    MERCHANT_ONBOARDING_FAILURE
} from './merchantOnboardingEntity';

export const fetchMerchantUrl = `${config.underwritingApiUrl}/onboarding/merchants`;

export function getMerchantOnboarding(filters, page, pageSize, sorters) {
    const queryParamsString = createQueryParams({
        filters,
        page,
        pageSize,
        sorters
    });

    return {
        failureActionTypeOrCreator: getMerchantOnboardingFailureActionCreator,
        fetchParams: {
            url: `${fetchMerchantUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: MERCHANT_ONBOARDING_LOAD,
        successActionTypeOrCreator: getMerchantOnboardingSuccessActionCreator
    };
}

export function getMerchantOnboardingSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, MERCHANT_ONBOARDING_SUCCESS, 'merchantOnboarding');
}

export function getMerchantOnboardingFailureActionCreator(error) {
    return {
        error,
        type: MERCHANT_ONBOARDING_FAILURE
    };
}

export function selectMerchant(history, merchant) {
    navigateToMerchantDetails(history, merchant.onboardingId);
}
